import { getBackendLanguage } from '@assets/i18n/config';
import { FormDefinitionStates } from '@generated/graphql';

export type FormDefinitionOption = {
  id: string;
  key: string;
  translatedName: unknown;
  objectType: string;
};

export const buildFetchFormDefinitionsVariables = (
  organizationId: string,
  filter?: Record<string, unknown>,
) => ({
  input: {
    filter: {
      states: [FormDefinitionStates.Active],
      ...filter,
      organizationId,
    },
    pagination: {
      perPage: 1000,
      sortField: `translatedName.${getBackendLanguage()}`,
      sortDesc: false,
    },
  },
});
